import { useEffect } from "react";

interface PageMetaOptions {
  title: string;
  description?: string;
}

/**
 * Custom hook to update page title and meta description
 * @param options - Page metadata options
 */
export const usePageMeta = ({ title, description }: PageMetaOptions) => {
  useEffect(() => {
    // Update page title
    document.title = `${title} | Casekeep`;

    // Update meta description if provided
    if (description) {
      let metaDescription = document.querySelector(
        'meta[name="description"]',
      ) as HTMLMetaElement;

      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }

      metaDescription.content = description;
    }

    // Cleanup: reset to default on unmount
    return () => {
      document.title = "Secure File Sharing for Small Business | Casekeep";
      const metaDescription = document.querySelector(
        'meta[name="description"]',
      ) as HTMLMetaElement;
      if (metaDescription) {
        metaDescription.content =
          "Secure file sharing for small business with the highest security. Collect sensitive documents via magic links with no client logins required. E-signatures and encrypted storage.";
      }
    };
  }, [title, description]);
};
